import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Routes, Route } from "react-router-dom";
import MyNavBar from "./components/MyNavBar";
import Footer from "./components/Footer";
import Homepage from "./pages/Homepage";
import Aboutpage from "./pages/Aboutpage";
import Products from "./pages/Products";
import Productpage from "./pages/Productpage";
import Projectspage from "./pages/Projectspage";
import CustomerServicespage from "./pages/CustomerServicespage";
import Loginpage from "./pages/Loginpage";
import Registerpage from "./pages/Registerpage";
import Accountpage from "./pages/Accountpage";
import LoungeProducts from "./pages/LoungeProducts";
import LoungeProductpage from "./pages/LoungeProductpage";
import Cartpage from "./pages/Cartpage";
import Checkoutpage from "./pages/Checkoutpage";

const App = () => {
  return (
    <>
      <MyNavBar />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/About" element={<Aboutpage />} />
        <Route path="/Products" element={<Products />} />
        <Route path="/Products/:slug" element={<Productpage />} />
        <Route path="/LoungeProducts" element={<LoungeProducts />} />
        <Route path="/LoungeProducts/:slug" element={<LoungeProductpage />} />
        <Route path="/Projects" element={<Projectspage />} />
        <Route path="/CustomerServices" element={<CustomerServicespage />} />
        <Route path="/Login" element={<Loginpage />} />
        <Route path="/Register" element={<Registerpage />} />
        <Route path="/Account" element={<Accountpage />} />
        <Route path="/Cart" element={<Cartpage />} />
        <Route path="/Checkout" element={<Checkoutpage />} />
      </Routes>
      <Footer />
    </>
  );
};

export default App;
